<template>
  <div class="email-preferences">
    <div class="text-body-3 text-secondary-1">Email preferences</div>

    <Grid gtc="1fr 1fr" gap="var(--r-space-md)" class="q-pl-md q-mt-sm">
      <RCheckbox
        v-for="preference of emailPreferences"
        :key="preference.id"
        :value="preferences"
        :label="preference.label"
        :val="preference.id"
        @input="$emit('input', $event)"
      />
    </Grid>
  </div>
</template>

<script>
// Libraries
import { cloneDeep } from 'lodash'

export default {
  props: {
    initialPreferences: Array
  },

  computed: {
    preferences() {
      return cloneDeep(this.initialPreferences.map(preference => preference.id))
    }
  }
}
</script>

<style lang="scss" scoped></style>
